export const ActionTypes = {
  LOADING: "GET_USER_PROFILE_LOADING",
  ERROR: "GET_USER_PROFILE_ERROR",
  SUCCESS: "GET_USER_PROFILE_SUCCESS",
};
